import { HTMLProps, forwardRef, useState } from 'react'
import { Button } from '../button'
import { Visibility, VisibilityOff } from '../icons'

export type PasswordInputProps = HTMLProps<HTMLInputElement> & {
  label?: string
  labelClassName?: string
  iconClassName?: string
  error?: string
  instructs?: string[]
  inputClassName?: string
}

export const PasswordInput = forwardRef<HTMLInputElement, PasswordInputProps>(
  (
    { label, labelClassName, className, iconClassName, instructs, error, inputClassName, ...props }: PasswordInputProps,
    ref
  ) => {
    const [visibility, setVisibility] = useState<boolean>(false)
    return (
      <div className={`flex flex-col gap-y-2 w-full`}>
        {label && (
          <span className={`text-white text-sm font-semibold ${labelClassName ? labelClassName : ''}`}>{label}</span>
        )}
        {instructs && (
          <ul className="list-disc pl-4">
            {instructs.map((item) => (
              <li key={item} className="text-xs text-navy-900 text-opacity-70">
                {item}
              </li>
            ))}
          </ul>
        )}
        <div
          className={`flex items-center p-3 md:p-4 border border-navy-900 border-opacity-20 rounded-full bg-white ${
            inputClassName ? inputClassName : ''
          }`}
        >
          <input
            ref={ref}
            type={visibility ? 'text' : 'password'}
            className={`text-sm focus:outline-none text-navy-900 w-full ${className}`}
            {...props}
          />
          <Button tabIndex={-1} type="button" className="hover:opacity-50 outline-none">
            {visibility ? (
              <VisibilityOff
                className={`w-6 h-6 text-gray-500 ${iconClassName}`}
                onClick={() => setVisibility(false)}
              />
            ) : (
              <Visibility className={`w-6 h-6 text-gray-500 ${iconClassName}`} onClick={() => setVisibility(true)} />
            )}
          </Button>
        </div>
        {error && <div className="text-boldOrange -mt-1 font-medium">{error}</div>}
      </div>
    )
  }
)
